import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const SidebarIcon = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx("svg", {
        ref: ref,
        ...props,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M13.4346 1.5C13.717 1.5 13.9888 1.6118 14.1885 1.81152C14.3882 2.01125 14.5 2.28297 14.5 2.56543V13.4346C14.5 13.717 14.3882 13.9888 14.1885 14.1885C13.9888 14.3882 13.717 14.5 13.4346 14.5H2.56543C2.28297 14.5 2.01125 14.3882 1.81152 14.1885C1.6118 13.9888 1.5 13.717 1.5 13.4346V2.56543C1.5 2.28297 1.6118 2.01125 1.81152 1.81152C2.01125 1.6118 2.28297 1.5 2.56543 1.5H13.4346ZM2.69043 13.3096H5.63965V2.69043H2.69043V13.3096ZM6.73047 13.3096H13.3096V2.69043H6.73047V13.3096Z"
        })
    }));
SidebarIcon.displayName = "SidebarIcon";
